import React, { Component } from "react";
import HdfcHeader from "../../common/components/pageBlocks/hdfcHeader";
import commonContext, { AppContext } from "../../common/context/common";
import { leadType } from "../../app";
import OtpInput from "../../common/components/otpInput";
import { ALDDApis } from "../apis/aLDDApis";
import { CommonApis } from "../../common/apis/commonApis";

interface IProps {
    history?: any;
}
interface IState {
    otp: string;
}
class FinalVerifyETB extends Component<IProps, IState> {
    static contextType = commonContext;
    lead: leadType;
    setLead: Function;
    base: any;
    apis: ALDDApis;
    cAPI: CommonApis;
    constructor(props: IProps) {
        super(props);
        this.state = {
            otp: "",
        };
    }
    async componentDidMount() {
        window.scrollTo(0, 0);
        this.setLead = (this.context as AppContext).setLead;
        this.lead = (this.context as AppContext).lead as leadType;
        this.apis = (this.context as AppContext).apis as ALDDApis;
        this.cAPI = (this.context as AppContext).commonAPI as CommonApis;
    }
    handleChange = (otp: any) => {
        this.setState({ otp });
        this.setLead({ otp: otp });
    };
    handleOnReset = () => {
        this.setLead({ otp: "" });
        this.setState({
            otp: "",
        });
    };
    handleOnOTPSubmit = async () => {
        this.lead = (this.context as AppContext).lead as leadType;

        const apiData = await this.apis.finalSubmit(this.lead);
        console.log(apiData);
        if (apiData.error.error) {
            console.log("otp invalid");
        } else if (!apiData.result.loanAvailed) {
            this.setLead({ confirmStatus: true });
            this.props.history.push("confirmation");
        } else {
            this.setLead({ confirmStatus: false });
            this.props.history.push("confirmation");
        }
    };
    handleOnResend = async () => {
        this.lead = (this.context as AppContext).lead as leadType;
        await this.cAPI.resendOTP(this.lead);
    };
    render() {
        this.lead = (this.context as AppContext).lead as leadType;
        this.base = (this.context as AppContext).base;
        return (
            <>
                <div className="wrapper">
                    <HdfcHeader />
                    <section className="landing-wrap mt-72 h-full ">
                        <div className="container mx-auto px-5 flex flex-wrap flex-col">
                            <div className="mb-6 mobile-otp-wrap mx-auto md:w-6/12 w-full">
                                <h1 className="openSans-Reg text-black my-8 text-3xl md:text-3xl lg:text-3xl xl:text-4xl">
                                    OTP
                                </h1>
                                <p className="openSans-Light text-black text-sm md:text-lg xl:text-xl">
                                    {" "}
                                    We sent you an OTP on your registered number
                                    ending with{" "}
                                    {((this.lead
                                        .mobile as unknown) as string).substr(
                                        ((this.lead
                                            .mobile as unknown) as string)
                                            .length - 4
                                    )}
                                </p>
                                <div className="openSans-Reg text-black text-sm md:text-lg xl:text-xl">
                                    <div className="w-full my-2">
                                        <form>
                                            <div className="w-full flex flex-wrap justify-center mx-auto">
                                                <OtpInput
                                                    value={this.state.otp}
                                                    onChange={this.handleChange}
                                                    numInputs={6}
                                                    inputStyle="otpinput w-full focus:border-red-500 active:border-red-500 block text-base lg:text-lg xl:text-xl border-b-2 border-gray-200 mx-1 text-black text-center"
                                                    containerStyle=""
                                                    placeholder=""
                                                    isInputNum={true}
                                                />
                                            </div>
                                        </form>
                                    </div>
                                    <p className="text-center openSans-Reg text-track text-sm mb-6">
                                        {/* {this.props.timer} */}
                                    </p>
                                    <p className="text-center openSans-Reg text-red-600 text-sm mb-6">
                                        {this.lead.otpAttemptsLeftText ? (
                                            <>
                                                Only {this.lead.otpAttemptsLeft}{" "}
                                                attempts left
                                            </>
                                        ) : (
                                            ""
                                        )}
                                    </p>
                                    <p className="text-center">
                                        <a
                                            href="javascript:;"
                                            className="blue-link-color no-underline hover:underline hover:text-black text-sm md:text-base lg:text-lg xl:text-lg transition-all openSans-SemiBold text-center"
                                            title="Resend OTP"
                                            onClick={() =>
                                                this.handleOnResend()
                                            }
                                        >
                                            Resend OTP
                                        </a>
                                    </p>
                                    <div className="w-full sm:w-10/12 mx-auto mt-8 flex flex-wrap justify-around">
                                        <div className="relative w-full sm:w-4/12 mx-auto mb-3 text-center">
                                            <button
                                                className="button-blue-bg hover:bg-blue-700 text-white py-2 px-4 rounded text-base lg:text-lg xl:text-xl button-blue mb-2 border-2 button-blue-border"
                                                title="Submit"
                                                onClick={() =>
                                                    this.handleOnOTPSubmit()
                                                }
                                            >
                                                Submit
                                            </button>
                                        </div>
                                        <div className="relative w-full sm:w-4/12 mx-auto mb-3 text-center">
                                            <button
                                                type="reset"
                                                className="bg-transparent border-2 button-blue-border blue-link-color hover:text-white py-2 px-4 rounded text-base lg:text-lg xl:text-xl button-blue button-white-blue mb-2 transition-all"
                                                title="Reset"
                                                onClick={() =>
                                                    this.handleOnReset()
                                                }
                                            >
                                                Reset
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <p className="openSans-Light text-black text-sm md:text-base">
                                Please enter the one time password received by
                                you on your registered mobile number for
                                agreeing and accepting and signing the Terms and
                                Conditions, the MITC, the SI and the
                                Application.
                                <br />
                                <br />
                                If you do not receive the OTP, try resending the
                                OTP by clicking on Resend OTP link. Please note
                                that you can Resend OTP only 3 times.
                            </p>
                        </div>
                    </section>
                </div>
            </>
        );
    }
}

export default FinalVerifyETB;
